import styles from 'styles/modules/SidescreenEditCompanyInfo.module.scss';
import { useState } from 'react';
import { profile } from 'lang/en.json';
import Typo from 'components/Typo';

const Description = ({ description, callback }) => {
    const [val, setVal] = useState(description || '');

    const handleChange = (e) => {
        setVal(e.target.value);

        if (callback) {
            callback(e.target.value);
        }
    };

    return (
        <div className={'mt-xxxs ml-xxxs mr-xxxs'}>
            <Typo
                variant={'body'}
                Tag={'label'}
                htmlFor="description"
                className={'mt-xs mb-xs'}
            >
                {profile.media_coverage.sidebar.coverage_text}
            </Typo>

            <textarea
                name="description"
                id="description"
                className={styles.descriptionTextarea}
                onChange={handleChange}
                value={val}
            />
        </div>
    );
};

export default Description;
